export const AddAmenitySteps = [
  { name: "Amenity Information" },
  { name: "Amenity Schedule" },
  { name: "Amenity Rules" },
  { name: "Confirmation" },
];
